"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ReportData_1 = tslib_1.__importDefault(require("../models/ReportData"));
const BaseRepository_1 = tslib_1.__importDefault(require("./BaseRepository"));
class ReportDataRepository extends BaseRepository_1.default {
    constructor() {
        super(...arguments);
        this.model = ReportData_1.default;
        this.summary = null;
        this.fetchOneQuery = () => Promise.resolve().then(() => tslib_1.__importStar(require('../gql/reports/queries/fetchOrganizationReportData.graphql')));
        this.fetchManyQuery = () => '';
    }
    fetchData(variables) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { entries, summary } = yield this.query(this.fetchOneQuery, variables);
            this.dataset = this.fromArray(entries);
            this.summary = summary;
            return this.dataset;
        });
    }
}
exports.default = ReportDataRepository;
//# sourceMappingURL=ReportDataRepository.js.map